<template>
  <div class="g-modal" v-if="message">
    <div class="g-content" v-click-outside="closeModal">
      <div class="header p-3 mb-2">
        <h4 class="m-0">توضیحات درخواست</h4>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="p-2 pt-0 mb-2">{{ message }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: null,
    };
  },
  methods: {
    init(_message) {
      this.message = _message;
    },

    closeModal() {
      this.message = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.g-modal {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;

  .g-content {
    background-color: #fff;
    border-radius: 4px;
    height: fit-content;
    max-width: 400px;
    width: 100%;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
    }
  }
}
</style>
